module.exports = __webpack_public_path__ + "assets/65b41c4138a0431a0e151d79b93ac291.mp3";